import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { MdxPage } from '@features/mdx/MdxPage';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[LanguageEnum.CZ]: '052c14da-29c1-4a2b-a4bb-e91e6cd9055b',
	[LanguageEnum.SK]: '052c14da-29c1-4a2b-a4bb-e91e6cd9055b',
	default: '052c14da-29c1-4a2b-a4bb-e91e6cd9055b'
}


export const Partners = () => {
	const { t } = useTranslation('web');

	return (
		<MdxPage className='partners-page' articleIds={articleIds}>
			
			<div className='partners-links'>
				<Link to={NavigateRoutesEnum.partnersOrder} className='app-form-button disable-selection'>
					{t('pages.partners.partnersOrderLink')}
				</Link>

				<Link to={NavigateRoutesEnum.partnersRegistration} className='app-form-button disable-selection'>
					{t('pages.partners.registrationLink')}
				</Link>
			</div>
		
		</MdxPage>
	);
};